<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Contrats</h1>
                    <p>Gestion des contacts</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

                <div class="actions">
                    <ul>
                        <li v-if="$aclInterfaceValidator('weeboxserevita.contract.create')">
                           <button-action  type="create"/>
                        </li>
                    </ul>
                </div>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" :active-date-filter="true" :active-advanced-filter="false" :active-tabs="true" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div v-bind:class="[ paginator.sort == 'firstname' ? 'active' : '', paginator.order ]">
                            <span data-sort="firstname" @click="setOrder($event)">Prénom</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'reference' ? 'active' : '', paginator.order ]">
                            <span data-sort="reference" @click="setOrder($event)">Reference</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'avs' ? 'active' : '', paginator.order ]">
                            <span data-sort="avs" @click="setOrder($event)">avs</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'birthdate' ? 'active' : '', paginator.order ]">
                            <span data-sort="birthdate" @click="setOrder($event)">Date naissance</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'amount_total' ? 'active' : '', paginator.order ]">
                            <span data-sort="amount_total" @click="setOrder($event)">Montant</span>
                        </div>
                        <div><span>Status</span></div>
                        <div><span>Download</span></div>
                        <div><span>Scope</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxserevita.contract.view', item.id )">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_files"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="firstname">
                            <strong>{{ item.firstname }} {{ item.lastname }}</strong>
                            <p>{{ item.origin_city }} / {{ item.origin_country_id }}</p>
                        </div>
                        <div data-field="reference">{{ item.reference }}</div>
                        <div data-field="avs">{{ item.avs }}</div>
                        <div data-field="birthdate">{{ item.birthdate }}</div>
                        <div data-field="amount_total" style="white-space: nowrap;text-transform: uppercase;">{{ item.currency_id }} {{ item.amount_total|formatNumber }}</div>
                        <div class="status">
                            <ul class="process" style="margin: 0;">
                                <li class="new" v-bind:class="{'active': item.status == 'new'}">
                                    <span>Nouveau</span>
                                </li>
                                <li class="sent" v-bind:class="{'active': item.status == 'sent' }">
                                    <span>Envoyé</span>
                                </li>
                                <li class="completed" v-bind:class="{'active': item.status == 'completed'}">
                                    <span>Payé</span>
                                </li>
                            </ul>
                        </div>
                        <div><a :href="item.card_link" target="_blank">Carte</a></div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li v-show="$aclInterfaceValidator('weeboxserevita.contract.delete', item.id)">
                                    <button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-show="$aclInterfaceValidator('weeboxserevita.contract.update', item.id)">
                                    <button @click="edit(item.id)"><icon name="pencil-02"/></button>
                                </li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import ContractService from './ContractService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                tabsFilter: [
                    {
                        slug: '',
                        name: 'Tout'
                    },
                    {
                        slug: 'new',
                        name: 'Nouveau'
                    },
                    {
                        slug: 'sent',
                        name: 'Envoyé'
                    },
                    {
                        slug: 'completed',
                        name: 'Signé/Payé'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ContractService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/serevita/contract/Index.vue